import { parseLegalMarkdown, type Inline } from '@/lib/legalMarkdown';

function Runs({ inlines }: { inlines: Inline[] }) {
  return (
    <>
      {inlines.map((run, i) =>
        run.bold ? <strong key={i}>{run.text}</strong> : <span key={i}>{run.text}</span>,
      )}
    </>
  );
}

/**
 * A SaaS document's text (M2-48). Its own `#` heading is drawn one level
 * below the screen's document heading (`baseLevel`), so the page's outline
 * stays in order whatever the file starts with.
 */
export function LegalMarkdown({ source, baseLevel = 3 }: { source: string; baseLevel?: number }) {
  const blocks = parseLegalMarkdown(source);
  return (
    <div className="space-y-3 text-sm leading-relaxed">
      {blocks.map((block, i) => {
        if (block.kind === 'heading') {
          const level = Math.min(6, baseLevel + block.level - 1);
          const Tag = `h${level}` as 'h3';
          return (
            <Tag
              key={i}
              className={level <= 3 ? 'text-base font-semibold' : 'text-sm font-semibold'}
            >
              <Runs inlines={block.inlines} />
            </Tag>
          );
        }
        if (block.kind === 'list') {
          return (
            <ul key={i} className="list-disc space-y-1 pl-5">
              {block.items.map((item, j) => (
                <li key={j}>
                  <Runs inlines={item} />
                </li>
              ))}
            </ul>
          );
        }
        return (
          <p key={i}>
            <Runs inlines={block.inlines} />
          </p>
        );
      })}
    </div>
  );
}
